var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"msui-iconfont icon",class:'ms-icon-' + _vm.name,style:({
    fontSize: _vm.fontSize
})})
}
var staticRenderFns = []

export { render, staticRenderFns }